import React from 'react';
import PropTypes from 'prop-types';
import ProgramAddOn from './ProgramAddOn';
import ServiceAddOn from './ServiceAddOn';


const ProductAddOnAvailable = (props) => {
  const { addOn: { type } } = props;

  const Component = {
    program: ProgramAddOn,
    service: ServiceAddOn,
  }[type];

  return Component ? <Component {...props} /> : null;
};

ProductAddOnAvailable.propTypes = {
  addOn: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductAddOnAvailable;
